import queryClient from '@/lib/queryClient';

export const useClearCache = () => {
  const clearCache = () => queryClient.clear();
  return { clearCache };
};
